export default __webpack_public_path__ + "static/media/s2_female.4ab461a2.wav";